import * as consentTypes from './consentTypes';
import { fetchConsentsByDefKey, saveConsentAcceptances, downloadSummary } from '../../../../services/consent.service';
import { push } from 'connected-react-router';
import { DASHBOARD_URL } from '../../../../constants/constants';
import { saveAPIFile } from 'src/helpers';

export const initPagesData = _pages => {
  return dispatch => {
    let pageIdx = 0;
    let pages = _pages.map(p => {
      return { id: p, accepted: false, read: false };
    });

    dispatch({
      type: consentTypes.INIT_CONSENT_LIST,
      pages,
      pageIdx,
      pageCount: _pages.length,
    });
  };
};

export const setCurrentPage = pageIdx => {
  return dispatch => {
    dispatch({
      type: consentTypes.SET_CURRENT_PAGE,
      pageIdx,
    });
  };
};

export const setCurrentPageRead = pageIdx => {
  return (dispatch, getState) => {
    const pages = getState().consent.pages;

    if (pageIdx === pages.length) {
      return;
    }

    pages[pageIdx].read = true;

    dispatch({
      type: consentTypes.SET_CURRENT_PAGE_READ,
      pageIdx,
      pages,
    });
  };
};

export const getConsentsByDefKey = pageIdx => {
  return async (dispatch, getState) => {
    const pages = getState().consent.pages;
    await fetchConsentsByDefKey(pages[pageIdx].id)
      .then(res => {
        if (res.success) {
          const state = getState().consent;
          let pages = state.pages;
          pages[pageIdx].consentData = res;
          dispatch(getConsentsSuccess(pageIdx, pages));
        } else {
          throw new Error(res.error.message);
        }
      })
      .catch(err => {
        console.error(err);
      });
  };
};

export const submitConsents = () => {
  return async (dispatch, getState) => {
    let acceptedConsents = [];
    const pages = getState().consent.pages;
    for (let i = 0; i < pages.length; i++) {
      acceptedConsents.push(pages[i].id);
    }
    await saveConsentAcceptances(acceptedConsents)
      .then(res => {
        if (res.success) {
          if (document.getElementsByClassName('nav-bar')) {
            document.getElementsByClassName('nav-bar')[0].style.display = 'block';
          }
          sessionStorage.removeItem('CN');
          dispatch(push(DASHBOARD_URL));
        } else {
          throw new Error(res.error.message);
        }
      })
      .catch(err => {
        console.error(err);
      });
  };
};

export const getConsentsSuccess = (pageIdx, pages) => {
  return dispatch => {
    dispatch({
      type: consentTypes.GET_CONSENT_SUCCESS,
      pageIdx,
      pages,
    });
  };
};

export const toggleConsent = value => {
  return (dispatch, getState) => {
    const state = getState().consent;
    let pages = state.pages;
    pages[state.pageIdx].accepted = value;
    dispatch({
      type: consentTypes.TOGGLE_CONSENT,
      pages,
    });
  };
};

export const downloadConsent = payload => {
  return async (dispatch, getState) => {
    await downloadSummary(payload)
      .then(res => {
        if (res.success) {
          saveAPIFile(res.consentfileData, res.fileName);
        } else {
          throw new Error(res.error.message);
        }
      })
      .catch(err => {
        console.error(err);
      });
  };
};
